module.exports = __webpack_public_path__ + "img/9788935702350.45f8934c.jpg";